import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/add.svg'
import _imports_1 from '@/assets/icons/addaddonenabled.svg'
import _imports_2 from '@/assets/icons/addaddondisabled.svg'
import _imports_3 from '@/assets/icons/deladdonenabled.svg'
import _imports_4 from '@/assets/icons/deladdondisabled.svg'
import _imports_5 from '@/assets/icons/delete.svg'
import _imports_6 from '@/assets/icons/deletedisabled.svg'


const _hoisted_1 = { class: "usrprdtext topmargin btm-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold-24" }, "Assigned Products", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"40px"},
  alt: "Assign products",
  title: "Click to assign products"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  src: _imports_1,
  style: {"width":"40px"},
  alt: "Add add-on",
  title: "Click to add add-ons"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_2,
  style: {"width":"40px"},
  alt: "Add add-on disabled",
  title: "Click to add add-ons"
}
const _hoisted_7 = {
  key: 0,
  src: _imports_3,
  style: {"width":"40px"},
  alt: "Delete add-on",
  title: "Click to delete add-ons"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_4,
  style: {"width":"40px"},
  alt: "Delete add-on disabled",
  title: "Click to delete add-ons"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_5,
  style: {"width":"40px"},
  alt: "Delete assigned products",
  title: "Click to remove assigned products"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_6,
  style: {"width":"40px"},
  alt: "Delete assigned products disabled",
  title: "Click to remove assigned products"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AssignedProducts = _resolveComponent("AssignedProducts")!
  const _component_AssignProductsModal = _resolveComponent("AssignProductsModal")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_AssignAddonModal = _resolveComponent("AssignAddonModal")!
  const _component_RemoveAddonsModal = _resolveComponent("RemoveAddonsModal")!
  const _component_RemoveEntitlementsModal = _resolveComponent("RemoveEntitlementsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _ctx.showAddProducts,
          id: "assignproduct"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _ctx.assignAddon,
          id: "addignaddon",
          disabled: !_ctx.enablebuttons
        }, {
          default: _withCtx(() => [
            (_ctx.enablebuttons)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (!_ctx.enablebuttons)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _ctx.removeAddon,
          id: "removeaddon",
          disabled: !_ctx.enablebuttons && _ctx.DisableDeleteAddon
        }, {
          default: _withCtx(() => [
            (_ctx.enablebuttons && !_ctx.DisableDeleteAddon)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.DisableDeleteAddon)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _ctx.removeEntitlements,
          id: "removeentitlement",
          disabled: !_ctx.enablebuttons
        }, {
          default: _withCtx(() => [
            (_ctx.enablebuttons)
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : _createCommentVNode("", true),
            (!_ctx.enablebuttons)
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _createVNode(_component_AssignedProducts),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAddprod,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAddprod) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignProductsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAssignAddon,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAssignAddon) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignAddonModal)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showRemoveAddon,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showRemoveAddon) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RemoveAddonsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showRemoveEntitlements,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showRemoveEntitlements) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RemoveEntitlementsModal)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}